import { createContext } from 'react';

import { Translate } from './types';

const defaultT: Translate = () => null;

defaultT.rebase = () => defaultT;
defaultT.locale = 'en';
defaultT.setLocale = () => {};

const TranslationContext = createContext<Translate>(defaultT);

export default TranslationContext;
